import api from 'api/api'
import { toast } from 'react-toastify'

import { API_URL } from 'constants/index'

export const GET_ITEMS_BY_PURCHASE_ID = '[PURCHASE ITEMS] GET ITEMS BY PURCHASE ID'

export function getItemsByPurchaseId(purchaseId) {
  const request = api.get(`/purchase-items/by-purchase/${purchaseId}`)
  return (dispatch) => {
    dispatch({ type: GET_ITEMS_BY_PURCHASE_ID, payload: { loading: true } })
    request.then((response) => {

      dispatch({ type: GET_ITEMS_BY_PURCHASE_ID, payload: { data: response.data.data } })
    }).catch((error) => {
      toast.error("Error inesperado, no se pudo obtener los items de la compra")
      console.log(GET_ITEMS_BY_PURCHASE_ID, error)
    }).finally(() => {
      dispatch({ type: GET_ITEMS_BY_PURCHASE_ID, payload: { loading: false } })
    })
  }
}
